import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import * as environment from '../environments/environment';
import { LoggingModule } from '@content-platform/web-angular-shared-util-logging';
import { AuthModule } from '@content-platform/web-angular-shared-util-auth';
import { NavigationModule } from '@content-platform/web-angular-shared-ui-navigation';
import { PermissionsModule, WebAngularSharedDataAccessApplicationApiModule } from '@content-platform/web-angular-shared-data-access-application-api';
import { InterceptorsModule } from '@content-platform/web-angular-shared-util-interceptors';
import { WebAngularSharedDataAccessFeatureFlagApiModule } from '@content-platform/web-angular-shared-data-access-feature-flag-api';
import { reducers } from './reducers';
import { isLocationPR, isRootApp, OktaFeatureFlagUserContext, WebAngularSharedDataAccessOktaAuth2Module } from '@content-platform/web-angular-shared-data-access-okta-auth2';
import { OktaAuthModule } from '@okta/okta-angular';
import { ApolloModule } from 'apollo-angular';
import { WebAngularSharedUtilOktaFeatureFlagUserContext } from '@content-platform/web-angular-shared-util-okta-feature-flag-user-context';
import * as i0 from "@angular/core";
const BASE_HREF = isLocationPR() || isRootApp() || window.location.origin.includes('localhost') ? '' : '/mip2';
export class AppModule {
    static { this.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [AppComponent] }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            { provide: WebAngularSharedUtilOktaFeatureFlagUserContext, useClass: OktaFeatureFlagUserContext },
            provideHttpClient(withInterceptorsFromDi())
        ], imports: [BrowserModule,
            CommonModule,
            BrowserAnimationsModule,
            AuthModule,
            OktaAuthModule,
            AppRoutingModule,
            LoggingModule.forRoot(),
            WebAngularSharedDataAccessApplicationApiModule.forRoot('Media Ingest Portal 2.0'),
            StoreModule.forRoot(reducers, {
                runtimeChecks: {
                    strictStateImmutability: false,
                    strictActionImmutability: false
                }
            }),
            WebAngularSharedDataAccessFeatureFlagApiModule,
            WebAngularSharedDataAccessOktaAuth2Module.forRoot(BASE_HREF),
            EffectsModule.forRoot([]),
            StoreDevtoolsModule.instrument({ logOnly: environment.production }),
            NavigationModule.forRoot(),
            PermissionsModule,
            InterceptorsModule,
            ApolloModule] }); }
}
//# sourceMappingURL=app.module.js.map